// export const API_URL = 'http://127.0.0.1:8000';
export const API_URL = process.env.REACT_APP_API;